import HomeNavBar from "./HomeNavBar";
const NotFound = () => {
  return (
    <div class="not-found">
      <HomeNavBar />
      <h1 class="text-5xl font-medium pt-9 pl-9">Oops... Page Not Found!</h1>
    </div>
  );
};
export default NotFound;
